import { Component, OnInit } from '@angular/core';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { OsobaRadnaOprema } from './osoba-radna-oprema';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'yt-osoba-radna-oprema-modal-update',
  templateUrl: './osoba-radna-oprema-modal-update.component.html'
})
export class OsobaRadnaOpremaModalUpdateComponent extends BaseModalUpdateComponent<OsobaRadnaOprema> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<OsobaRadnaOprema>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
  ) { 
    super(modalContainerService, activeModal,modalService);
  }

  ngOnInit() {
  }

}
